/**
 * Supports an optional cleanup operation UIcontainer children upon close.
 * Notably the cleanup operation can be performed asynchronously and UIContainer close will block until all
 * cleanups have been completed.
 *
 * @module MW/uiframework/uicontainer/CleanupManager
 * @copyright Copyright 2018 The MathWorks, Inc.
 */
define(["dojo/Deferred",
        "mw-log/Log"
       ],
    function (Deferred, Log) {

        var pendingCleanups = [];
        var doneDeferred;

        return {
            cleanup: function (properties) {
                if (properties.cleanup || typeof properties.cleanup === "function") {
                    var cleanup = properties.cleanup();
                    delete properties.cleanup;  // prevent multiple calls to cleanup
                    if (cleanup && cleanup.then) {
                        pendingCleanups.push(cleanup);
                        cleanup.then(function () {
                            var index = pendingCleanups.indexOf(cleanup);
                            if (index >= 0) {
                                pendingCleanups.splice(index, 1);
                                if (doneDeferred && pendingCleanups.length === 0) {
                                    doneDeferred.resolve();
                                }
                            }
                        });
                    }
                }
            },

            completePendingCleanups: function() {
                Log.assert(!doneDeferred, "Concurrent completePendingCleanups not supported");
                doneDeferred = new Deferred();
                if (pendingCleanups.length === 0) {
                    doneDeferred.resolve();
                }
                return doneDeferred.promise;
            }
        };
    });